import { Behavior } from '@cewe-designsystem/abstract';
import UtilBrowserDetection from '@cewe-designsystem/util_browser-detection';
import { Device } from '@cewe-designsystem/util_browser-detection';

@Behavior('browser-detection')
export class BrowserDetection {
  handler: unknown;
  element: Element;

  browserDetection: UtilBrowserDetection;
  os: string;
  browser: string;
  device: Device;

  constructor(element: Element) {
    this.element = element;

    this.browserDetection = new UtilBrowserDetection();
    this.os = this.browserDetection.getOs();
    this.browser = this.browserDetection.getBrowser();
    this.device = this.browserDetection.getDevice();
  }

  // called when the `element` is added to the DOM
  connectedCallback() {
    this.element.setAttribute('browser-detection-os', this.os);
    this.element.setAttribute('browser-detection-browser', this.browser);
    this.element.setAttribute('browser-detection-device', this.device.device);
    this.element.setAttribute('browser-detection-type', this.device.type);
  }

  // called when the `element` is removed from the DOM
  disconnectedCallback() {}
}
